import React from 'react'
import { getCodeTranslate } from 'LibNeo'
import { Popconfirm } from 'antd'
import { PopconfirmProps } from 'antd/lib/popconfirm'

export const getTitle = (
	title?: string | JSX.Element,
	titleCode?: string
): string | JSX.Element => {
	const defaultTitle = title || ''
	return titleCode ? getCodeTranslate(titleCode) : defaultTitle
}

export const getPopConfirm = (
	elem: JSX.Element,
	popConfirmProps: PopconfirmProps,
	disabled = false
): JSX.Element => {
	if (popConfirmProps && !disabled) {
		return <Popconfirm {...popConfirmProps}>{elem}</Popconfirm>
	}
	return elem
}

export const isWinOs = () => window.navigator.appVersion.includes('Win')
